import {
  LOAD_CREDENTIALS,
  LOAD_CREDENTIALS_SUCCESS,
  UPDATE_CREDENTIAL,
  UPDATE_CREDENTIAL_SUCCESS,
  DELETE_CREDENTIAL,
  DELETE_CREDENTIAL_SUCCESS,
  LOAD_CREDENTIAL_GROUPS,
  LOAD_CREDENTIAL_GROUPS_SUCCESS,
  UPDATE_CREDENTIAL_GROUP,
  UPDATE_CREDENTIAL_GROUP_SUCCESS,
  DELETE_CREDENTIAL_GROUP,
  DELETE_CREDENTIAL_GROUP_SUCCESS,
  ADD_TO_FAVORITE,
  REMOVE_FROM_FAVORITE,
  CHANGE_FAVORITE,
  LOAD_MODERATED_CREDENTIALS_SUCCESS,
  LOAD_CREDENTIAL_BY_ID_SUCCESS,
  CHECK_CREDENTIAL_PASSWORD,
  LOAD_CREDENTIAL_FIELDS,
  CLEAR_CREDENTIAL_GROUPS,
} from 'constants/ActionTypes';

import { getIntlMessage, getJwtToken } from 'helpers/utilHelpers';
import { getCookie, setCookie } from 'helpers/cookieHelpers';

import { toggleCredentialForm } from 'actions/ui/credentialListActions';
import { toggleCredentialGroupForm } from 'actions/ui/groupTableActions';

// Begin loading of the credentials
export const loadCredentials = (payload = {}) => {
  return {
    type: LOAD_CREDENTIALS,
    payload: {
      resource: 'credentials',
      extraFields: ['group'],
      onSuccess: loadCredentialsSuccess,
      onErrorMessage: getIntlMessage('credential.load.error'),
      ...payload,
    },
  };
};

// Begin loading of the credential by id
export const loadCredentialById = (accessId, payload = {}) => {
  return {
    type: LOAD_CREDENTIALS,
    payload: {
      resource: 'credentials/' + accessId,
      extraFields: ['group'],
      onSuccess: loadCredentialByIdSuccess,
      onErrorMessage: getIntlMessage('credential.load.error'),
      ...payload,
    },
  };
};

// Credential update request
export const updateCredential = (payload = {}) => {
  return {
    type: UPDATE_CREDENTIAL,
    promise: { ...payload.promise },
    payload: {
      resource: 'credentials',
      onSuccess: (values) => updateCredentialSuccess(values, payload.isModerate),
      afterSuccess: toggleCredentialForm,
      entityPrimaryKey: 'accessId',
      ...payload,
    },
    values: { ...payload.values, token: getCookie('master_password') },
  };
};

// Sending a request to the server to delete credential
export const deleteCredential = (accessId) => {
  return {
    type: DELETE_CREDENTIAL,
    payload: {
      resource: 'credentials',
      entityId: accessId,
      onSuccess: deleteCredentialSuccess,
      onErrorMessage: getIntlMessage('credential.delete.error'),
      queryParams: { token: getCookie('master_password') },
    },
  };
};

// Begin loading of the credential groups
export const loadCredentialGroups = (payload = {}) => {
  return {
    type: LOAD_CREDENTIAL_GROUPS,
    payload: {
      resource: 'credential-groups',
      onSuccess: loadCredentialGroupsSuccess,
      onErrorMessage: getIntlMessage('group.load.error'),
      ...payload,
    },
  };
};

// Credential group update request
export const updateCredentialGroup = (payload = {}) => {
  return {
    type: UPDATE_CREDENTIAL_GROUP,
    promise: { ...payload.promise },
    payload: {
      resource: 'credential-groups',
      onSuccess: updateCredentialGroupSuccess,
      afterSuccess: toggleCredentialGroupForm,
      entityPrimaryKey: 'groupId',
      ...payload,
    },
    values: payload.values,
  };
};

// Sending a request to the server to delete credential group
export const deleteCredentialGroup = (groupId) => {
  return {
    type: DELETE_CREDENTIAL_GROUP,
    payload: {
      resource: 'credential-groups',
      entityId: groupId,
      onSuccess: deleteCredentialGroupSuccess,
      onErrorMessage: getIntlMessage('group.delete.error'),
    },
  };
};

// Sending a request to the server to add favorites
export const addToFavorite = (accessId) => {
  return {
    type: ADD_TO_FAVORITE,
    payload: {
      resource: 'credential-favorite-maps',
      onSuccess: () => changeToFavoriteSuccess(accessId, true),
      onErrorMessage: getIntlMessage('request.error'),
    },
    values: { accessId },
  };
};

// Sending a request to the server to delete favorites
export const removeFromFavorite = (accessId) => {
  return {
    type: REMOVE_FROM_FAVORITE,
    payload: {
      resource: 'credential-favorite-maps',
      entityId: accessId,
      onSuccess: (accessId) => changeToFavoriteSuccess(accessId, false),
      onErrorMessage: getIntlMessage('request.error'),
    },
  };
};

// Update credential favorite if sending succeed
export const changeToFavoriteSuccess = (accessId, change) => {
  return {
    type: CHANGE_FAVORITE,
    accessId,
    change,
  };
};

// Actions success
// --------------------

// Update credentials if loading is succeed
export const loadCredentialsSuccess = (credentials) => {
  return {
    type: LOAD_CREDENTIALS_SUCCESS,
    credentials,
  };
};

export const loadCredentialByIdSuccess = (access) => {
  return {
    type: LOAD_CREDENTIAL_BY_ID_SUCCESS,
    access,
  };
};

// Credential update success
export const updateCredentialSuccess = (credential, isModerate = false) => {
  return {
    type: UPDATE_CREDENTIAL_SUCCESS,
    credential,
    isModerate,
  };
};

// Delete credential if sending succeed
export const deleteCredentialSuccess = (accessId) => {
  return {
    type: DELETE_CREDENTIAL_SUCCESS,
    accessId,
  };
};

// Update credential groups if loading is succeed
export const loadCredentialGroupsSuccess = (credentialGroups) => {
  return {
    type: LOAD_CREDENTIAL_GROUPS_SUCCESS,
    credentialGroups,
  };
};

export const clearCredentialGroups = () => {
  return {
    type: CLEAR_CREDENTIAL_GROUPS,
  };
};

// Credential group update success
export const updateCredentialGroupSuccess = (group) => {
  return {
    type: UPDATE_CREDENTIAL_GROUP_SUCCESS,
    group,
  };
};

// Delete credential group if sending succeed
export const deleteCredentialGroupSuccess = (groupId) => {
  return {
    type: DELETE_CREDENTIAL_GROUP_SUCCESS,
    groupId,
  };
};

// Moderated credentials success
export const loadModeratedCredentialsSuccess = (credentials) => {
  return {
    type: LOAD_MODERATED_CREDENTIALS_SUCCESS,
    credentials,
  };
};

// Sending a request to the server to delete favorites
export const checkCredentialPassword = (password, successCallback, onErrorFunction) => {
  return {
    type: CHECK_CREDENTIAL_PASSWORD,
    payload: {
      resource: 'credentials/access',
      onSuccessFunction: (response) => {
        setCookie('master_password', response, 30 * 60);
        successCallback(true);
      },
      onErrorFunction,
    },
    values: { token: getJwtToken({ password }) },
  };
};

export const loadCredentialFields = (payload = {}) => {
  return {
    type: LOAD_CREDENTIAL_FIELDS,
    payload: {
      resource: `credentials/${payload.accessId}/fields`,
      onErrorMessage: getIntlMessage('request.error'),
      ...payload,
      queryParams: { token: getCookie('master_password'), ...payload.queryParams },
    },
  };
};
